import Tab from 'components/common/Tab';
import { constant } from 'constants/constant';
import React, { useState } from 'react'
import { RxCross1, RxCross2 } from 'react-icons/rx'

const TransactionExpDetails = () => {
  const [activeTab, setActiveTab] = useState(1);

  const tabProps = {
    tabList: constant.transactionExpensesTabs,
    callBackTab: (e) => setActiveTab(e),
    activeTab: activeTab,
    isActiveButton: true,
    tabButtonName: 'Record Payment',
  };


  return (
    <div className='trs-listDetail'>
      <div className='trs-listBx_ns'>
        <div className='trs-dropDown-head'>
          <div class="dropdown">
            <button
              class=" dropdown-toggle "
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              General Expenses
            </button>
            <ul class="dropdown-menu ">
              {/* {userSettingPermission?.expenses_approval === 1 && ( */}
              <li>
                <a
                  class="dropdown-item px-2"
                // onClick={() =>
                //   expenseOnClick((pre) => ({
                //     ...pre,
                //     title: "expense",
                //     open: true,
                //   }))
                // }
                >
                  EMI
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item px-2"
                // onClick={() => expenseOnClick((pre) => ({ ...pre, title: "general_receipt", open: true }))}
                >
                  Servicing
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item px-2"
                // onClick={() =>
                //   expenseOnClick((pre) => ({
                //     ...pre,
                //     title: "transfer",
                //     open: true,
                //   }))
                // }
                >
                  Documents
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className='trs-listBx_ns_content'>
          <div className='trs-listBx_ns_content_list'>
            <div className='trs-line active'>
              <div className='trs-listBx-heading'>
                <p>Customer Name</p>
                <span>EXP2025-232 | 18/2/2026</span>
                <div className='trs-status'>Unpaid</div>
              </div>
            </div>

            <div className='trs-line '>
              <div className='trs-listBx-heading'>
                <p>Customer Name</p>
                <span>EXP2025-232 | 18/2/2026</span>
                <div className='trs-status'>Unpaid</div>
              </div>
            </div>

            <div className='trs-line '>
              <div className='trs-listBx-heading'>
                <p>Customer Name</p>
                <span>EXP2025-232 | 18/2/2026</span>
                <div className='trs-status'>Unpaid</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='trs-detailBx'>
        <div className='trs-detailBx_head'>
          <div className='trs-left-head'>
            <p>Sales Invoice 1</p>
            <div className='trs-status'>Pending</div>
          </div>

          <div className='trs-right-head'>
            <button className='trs-dwn-btn anime-btn'>Download PDF</button>
            <button className='trs-dwn-btn anime-btn'>Print Voucher</button>
            <button className='trs-cancel-btn'><RxCross2 /></button>
          </div>
        </div>

        <div className='trs-inp-tabBxs'>
          <div className="addPr_flBx __uiTx_new">
            <Tab {...tabProps} />

            <div className='trs-inp-tabContent'>
              {activeTab === 1 && <>Invoice Preview</>}
              {activeTab === 2 && <>
                <div className="trs-payment-history-card">
                  <div className="trs-ph-header">
                    <h3>Payment History</h3>
                    
                    <div className="trs-ph-row">
                      <span className="trs-ph-label">Invoice Amount</span>
                      <span className="trs-ph-amount">₹ 63,000.00</span>
                    </div>
                  </div>


                  <div className="trs-ph-payment-box">
                    <div className="trs-ph-payment-row">
                      <div>
                        <div className="trs-ph-payment-title">Payment</div>
                        <div className="trs-ph-payment-meta">
                          12 Jan 2023 | V012 | Bank Account
                        </div>
                      </div>
                      <div className="trs-ph-payment-amount">₹ 5000.00</div>
                    </div>

                    <div className="trs-ph-divider"></div>

                    <div className="trs-ph-payment-row">
                      <div>
                        <div className="trs-ph-payment-title">
                          Payment <span className="trs-ph-badge">Under Approval</span>
                        </div>
                        <div className="trs-ph-payment-meta">
                          12 Jan 2023 | V012 | Bank Account
                        </div>
                      </div>
                      <div className="trs-ph-payment-amount">₹ 5000.00</div>
                    </div>
                  </div>

                  <div className="trs-ph-footer">
                    <div className="trs-ph-row">
                      <span className="trs-ph-label">Invoice Amount Received</span>
                      <span className="trs-ph-amount">₹ 0.00</span>
                    </div>

                    <div className="trs-ph-row">
                      <span className="trs-ph-label trs-ph-danger">Balance Due</span>
                      <span className="trs-ph-amount trs-ph-danger">₹ 63,000.00</span>
                    </div>
                  </div>
                </div>
              </>}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TransactionExpDetails